module.exports = __webpack_public_path__ + "static/media/54799701_2519303654811477_2083435102817222656_o.7195b85c.jpg";